/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Input from '../../../adminv2/common/Input'
import Select from 'react-select'
import CoreV2 from '@services/CoreV2'
import CompanyModal from './Company.Modal'
import Alert from '../../../adminv2/common/Alert'
import CheckboxRadio from '../../../adminv2/common/CheckboxRadio'
import { history } from '@services/History'
import { useDispatch } from 'react-redux'
import { showAlert } from '../alert/Alert.dux'
import _ from 'lodash'

export default function CompanyWelcomeMessageForm(props) {
  const dispatch = useDispatch()
  let company = props.company
  let { formData, setFormData, initialFormData, setInitialFormData } = props

  const campaignClient = CoreV2.campaigns
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)

  const [welcomeMessage, setWelcomeMessage] = useState('')
  const [campaign, setCampaign] = useState()
  const [specialities, setSpecialities] = useState(props.specialities)
  const [selectedSpeciality, setSelectedSpeciality] = useState()
  const [statusOptions, setStatusOptions] = useState()

  useEffect(() => {
    getAndSetCampaignInfo()
  }, [])

  const initializeFormData = (options) => {
    let initial = {
      is_enabled: options?.is_enabled ? 'on' : 'off' || '',
      message: options?.message || '',
      speciality_id: options?.speciality_id || '',
    }
    setInitialFormData(initial)
    setFormData(initial)
  }

  const getAndSetCampaignInfo = async () => {
    let selectFormatted = []
    const orderSpecialitiesByName = specialities.sort((a, b) => (b.name < a.name ? 1 : -1))
    selectFormatted = orderSpecialitiesByName.map((element) => ({
      value: element.id,
      label: element.name,
      code: element.code,
    }))
    setSpecialities(selectFormatted)

    campaignClient
      .getCampaignByCompany(company.id)
      .then((response) => {
        if (response.data) {
          let campaign = response.data.length > 0 ? response.data[0] : {}
          const { attributes } = campaign
          let statusOptions = [
            {
              label: t('active'),
              checked: attributes && attributes.is_enabled ? true : false,
              value: 'on',
              name: 'active',
            },
            {
              label: t('baja'),
              checked: !attributes || !attributes.is_enabled ? true : false,
              value: 'off',
              name: 'inactive',
            },
          ]

          setCampaign(attributes ? attributes : {})
          initializeFormData(attributes)
          setWelcomeMessage(attributes?.message)
          setStatusOptions(statusOptions)
          setSelectedSpeciality(
            selectFormatted.find((element) =>
              element.value === attributes?.speciality_id ? attributes?.speciality_id : null
            )
          )
        } else {
          failureAlertOpening()
        }
      })
      .catch(() => {
        setStatusOptions([
          {
            label: t('active'),
            checked: false,
            value: 'on',
            name: 'active',
          },
          {
            label: t('baja'),
            checked: true,
            value: 'off',
            name: 'inactive',
          },
        ])

        dispatch(
          showAlert({
            text: t('integrationErrorGetting'),
            important: 'Ups!',
            type: 'danger',
          })
        )
      })
  }

  const successAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdateSuccessMessage'),
        important: t('goodJob'),
        type: 'success',
      })
    )
  }

  const failureAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdatingErrorMEssage'),
        important: 'Oh snap!',
        type: 'danger',
      })
    )
  }
  const formatData = (params) => {
    let result = {
      type: 'welcome',
      company_id: company.id,
      speciality_id: selectedSpeciality?.value,
      message: params.welcomeMessage,
      name: 'test',
      is_enabled: params.status === 'on' ? true : false,
      is_paused: params.status === 'on' ? false : true,
    }

    return result
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = document.getElementById('welcomemessage-form')
    const formDataLocal = new FormData(form)
    const formProps = Object.fromEntries(formDataLocal)
    let params = formatData(formProps)

    if (company.id) {
      if (campaign.id) {
        campaignClient
          .patchCampaignByCompany(campaign.id, params)
          .then((res) => successAlertOpening())
          .then(setInitialFormData(formData))
          .catch((err) => {
            failureAlertOpening()
          })
      } else {
        campaignClient
          .postCampaignByCompany(params)
          .then((res) => successAlertOpening())
          .then(setInitialFormData(formData))
          .catch((err) => {
            failureAlertOpening()
          })
      }
    }
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }

  return (
    <div className="companies-form md-form">
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('welcomeMessage-submit-btn').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/companies')}
        />
      ) : null}
      <Alert timeOut={3000} />
      <form className="welcomemessage-form" onSubmit={handleSubmit} id="welcomemessage-form">
        <h1>{t('welcomeMessage')}</h1>
        <CheckboxRadio
          className="form-control"
          id="status"
          name="status"
          label={`Status`}
          options={statusOptions}
          handleOptions={(options) => {
            setStatusOptions(options)
            setFormData({ ...formData, is_enabled: options.find((e) => e.checked).value })
          }}
          type="radio"
          required
        />
        <Input
          className="form-control"
          id="welcomeMessage"
          name="welcomeMessage"
          label={t('welcomeMessageLabel')}
          defaultValue={welcomeMessage || ''}
          onChange={(e) => {
            setWelcomeMessage(e.target.value)
            setFormData({ ...formData, message: e.target.value })
          }}
          required
          type="textarea"
          disabled={statusOptions && statusOptions[1].checked}
        />
        {specialities ? (
          <div>
            <label>{`${t('Especialidades')}*:`}</label>
            <Select
              name="speciality"
              options={specialities}
              value={selectedSpeciality}
              onChange={(option) => {
                setSelectedSpeciality(option)
                setFormData({ ...formData, speciality_id: option.value })
              }}
              isDisabled={statusOptions && statusOptions[1].checked}
              required
            />
          </div>
        ) : null}
        <div className="companies-form--buttonsContainer">
          <button
            type="submit"
            className="btn btn-primary"
            id="welcomeMessage-submit-btn"
            disabled={checkUnsavedChanges() || (statusOptions && statusOptions[1].checked && !campaign.company_id)}
          >
            {t('Guardar')}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              if (checkUnsavedChanges()) {
                history.push('/companies')
              } else {
                setShowModal(true)
              }
            }}
          >
            {t('Cancelar')}
          </button>
        </div>
      </form>
    </div>
  )
}
